// extracted by mini-css-extract-plugin
module.exports = {"heading":"intro_heading__MvbPU"};